'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useRouter } from 'next/navigation';

function DevelopmentErrorInfo({ error }) {
  return (
    <>
      <p className="text-gray-600 font-bold">{error.message}</p>
      {error.stack && (
        <pre className="mt-2 text-sm text-gray-500 overflow-scroll">
          {error.stack}
        </pre>
      )}
      {error.status && (
        <p className="mt-2 text-sm text-gray-500">{error.status}</p>
      )}
      {error.statusText && (
        <p className="mt-2 text-sm text-gray-500">{error.statusText}</p>
      )}
      {error.body && <p className="mt-2 text-sm text-gray-500">{error.body}</p>}
      {error.jsonBody && (
        <p className="mt-2 text-sm text-gray-500">{error.jsonBody}</p>
      )}
    </>
  );
}

export default function ErrorComponent({ error, reset }) {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const router = useRouter();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Card className="w-full max-w-xl">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">
            Oops! Something went wrong
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-1xl mb-3">
            An unexpected error occurred. Please try again later.
          </p>
          {isDevelopment && <DevelopmentErrorInfo error={error} />}
        </CardContent>
        <CardFooter className="flex justify-between">
          <Button variant="outline" onClick={() => router.back()}>
            Go back
          </Button>
          {reset && <Button onClick={reset}>Try again</Button>}
        </CardFooter>
      </Card>
    </div>
  );
}
